import React, { Component } from 'react';
import axios from 'axios';
import ReactGA from 'react-ga';

import getConfig from '../../config';
import { withRouter } from 'react-router';
import {isEmailValid} from '../../utils/regex'
import './password_reset_handler.css';

class ForgotPassword extends Component {

    constructor(props) {
        super(props);
        this.state = {
            email: ""
        };

        this.handleSendPasswordResetEmail = this.handleSendPasswordResetEmail.bind(this);
        this.handleEmailUpdate = this.handleEmailUpdate.bind(this);
    }

    handleEmailUpdate(event) {
        this.setState({ email: event.target.value });
    }


    handleSendPasswordResetEmail(e) {
        e.preventDefault();
        if (!isEmailValid(this.state.email)) {
            alert("Invalid Email address");
            return;
        }
        let forgotPasswordEmail = this.state.email;
        const config = getConfig();
        const url = config.daisy.domain + config.daisy.services.send_password_reset_email;
        const data = { "email": forgotPasswordEmail };
        console.log("Email Verification Url:", url)
        console.log("Email Verification Data:", data)
        ReactGA.event({
            category: 'Login',
            action: 'Forget Password Button Click',
            label: data
        });
        axios.post(
            url,
            data
        ).then(resp => {
            this.setState({ emailSent: true });
            console.log('Email sent');
        }).catch(err => {console.log(err)
            const errorMsg = JSON.stringify(err);
            ReactGA.event({
                category: 'Login',
                action: 'Forget Password Error',
                label: errorMsg
            });});
    }

    render() {
        ReactGA.pageview('/forget-password');
        return (
            <div className="login-form">
                <h1>Forgot your password?</h1>
                {
                    !this.state.emailSent ?
                        <div>
                            <form id='credential-form'>
                                <input type="text" placeholder="Email" value={this.state.email} onChange={this.handleEmailUpdate} />
                            </form>

                            <div className='action-buttons'>
                                <form onSubmit={this.handleSendPasswordResetEmail} id='signup-form'>
                                    <input type="submit" value="Send Password Reset Email" />
                                </form>
                            </div>
                        </div>
                        :
                        (
                            <div className="description">
                                <h2>PASSWORD RESET LINK SENT</h2>
                                    Please check your email for link to reset your password.
                            </div>)
                }
            </div>
        )
    }
}

export default withRouter(ForgotPassword);
